import store from '../store'
import { API } from 'aws-amplify';

let socket = null;
let isConnected = false;
let heartbeatInterval = null;
const HEARTBEAT_INTERVAL = 8 * 60 * 1000;

let reconnectTimer = null;
export let reconnectAttempts = 0;
const baseReconnectInterval = 3000;
let reconnectInterval = baseReconnectInterval;
const maxReconnectAttempts = 3;


export function initWebSocket(url) {
  if (socket && (socket.readyState === WebSocket.CONNECTING || socket.readyState === WebSocket.OPEN)) {
    console.warn("⚠️ WebSocket already connecting or connected");
    return socket;
  }

  socket = new WebSocket(url);

  socket.onopen = () => {
    isConnected = true;
    clearTimeout(reconnectTimer);
    reconnectAttempts = 0;
    reconnectInterval = baseReconnectInterval;
    sendMessage({ action: "sendmessage" });
    startHeartbeat();
  };

  socket.onmessage = (event) => {
    const data = JSON.parse(event.data);

    if (data.type === "connection_ack") {
      store.commit("setUserConnection", data.connectionId);
      updateResourceConnectionIdentifier(data.connectionId);
    }
  };

  socket.onerror = (error) => {
    console.error(`❌ Could not connect to the websocket`, error);
    isConnected = false;
  };

  socket.onclose = (event) => {
    isConnected = false;
    stopHeartbeat();

    if (event.code === 1000) {
      socket = null;
    }
  };

  store.commit("setSocket", socket);
}

export function sendMessage(payload) {
  if (socket && socket.readyState === WebSocket.OPEN) {
    try {
      socket.send(JSON.stringify(payload));
      return true;
    } catch (error) {
      console.error("Error sending message:", error);
      return false;
    }
  } else {
    console.warn("⚠️ WebSocket not connected, cannot send message");
    return false;
  }
}

export function closeWebSocket(reason="Client closed") {
  clearTimeout(reconnectTimer);
  reconnectTimer = null;
  reconnectAttempts = 0;
  reconnectInterval = baseReconnectInterval;
  if (socket) {
    stopHeartbeat();
    socket.close(1000, reason);
    socket = null;
    isConnected = false;
    store.commit("setSocket", null);
  }
}

export function startHeartbeat() {
  if (!socket || socket.readyState !== WebSocket.OPEN) return;
  if (heartbeatInterval) {
    clearInterval(heartbeatInterval);
  }
  heartbeatInterval = setInterval(() => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      sendMessage({ action: 'heartbeat', type: 'ping' });
    } else {
      stopHeartbeat();
    }
  }, HEARTBEAT_INTERVAL);
}

export function stopHeartbeat() {
  if (heartbeatInterval) {
    clearInterval(heartbeatInterval);
    heartbeatInterval = null;
  }
}

export function getConnectionState() {
  return {
    isConnected,
    readyState: socket ? socket.readyState : WebSocket.CLOSED,
    reconnectAttempts
  };
}

function updateResourceConnectionIdentifier(connectionId) {
  try {
    const noteTypeInUse = store.getters.getNoteTypeInUse;
    let identifier;
    switch (noteTypeInUse) {
      case 'GENERAL_NOTE':
        identifier = store.getters.getGeneralNoteIdentifier;
        break;
      case 'FLEET_NOTE':
        identifier = store.getters.getFleetNoteIdentifier;
        break;
      case 'STANDUP_NOTE':
        identifier = store.getters.getStandupNoteIdentifier;
        break;
      default:
        break;
    }
    let resourceUsage = store.state.subscriptionStore.resourceUsageList.find(resourceUsage =>resourceUsage.resourceIdentifier === identifier);
    if (!resourceUsage) return

    const resourceInput = {
      id: resourceUsage.id,
      connectionId
    };
    let apiName = "heraPublicApi";
    let path = "/executeMutation";
    let post = {
      body: {
        type: "resource-usage",
        mutation: "update",
        group: store.state.userInfo.tenant.group,
        owner: store.state.userInfo.cognitoSub,
        items: { ...resourceInput },
      },
    };
    safeFunction(API.post)(apiName, path, post);
  } catch (error) {
    console.log({error});
  }
}

export function reconnectWebSocket(url) {
  if (reconnectAttempts >= maxReconnectAttempts) {
    console.error("❌ Maximum retry limit reached. No further reconnection will occur.");
    return;
  }
  reconnectAttempts++;
  console.log(`🔌 Reconnection attempt #${reconnectAttempts} in ${reconnectInterval}ms…`);
  reconnectTimer = setTimeout(() => {
    initWebSocket(url);
    // back‑off exponencial opcional:
    reconnectInterval = Math.min(reconnectInterval * 2, 60000); 
  }, reconnectInterval);
}